<template>
  <div v-if="loading" class="fh fw center">
    <loadingCircle/>
  </div>
  <div v-else class="part-id-generation">
      <div class="flex">
        <img
          class="mr-3"
          src="~@/assets/images/icons/arrow-back.svg"
          width="30px"
          alt=""
          @click="goBack"
        />
        <div class="xxxl weight-500">Sequence Generation</div>
      </div>
    <div class="new-component-header">
      <div class="flex gap-1" style="gap: 10px; align-items: center;">
        <div v-if="!viewMode" class="create-header flex gap-1 center">
          <label style="font-weight: 500;">Template Name:</label>
          <input
            v-if="!viewMode"
            type="text"
            class="sort"
            placeholder="Template Name"
            v-model="templateName"
          />
          <label style="font-weight: 500;" for="">Link To:</label>
          <select
            v-if="!viewMode"
            class="sort"
            v-model="selectedFeature"
          >
            <option disabled value='null'>Select Feature</option>
            <option
              v-for="(value, key) in filteredCoreFeatures"
              :key="value"
              :value="value"
            >
              {{ key }}
            </option>
          </select>
        </div>
        <div v-else class="header-view center flex gap-1">
          <label style="font-weight: 500;">Template Name:</label>
          <div class="status status-inprogress">
            {{ templateName || '--' }}
          </div>
          <label style="font-weight: 500;">Linked To:</label>
          <div class="status status-inprogress">
            {{ linkedTo || '--' }}
          </div>
        </div>
      </div>
      <button v-if="!viewMode" class="btn" @click="saveComponent">+ Save</button>
    </div>
    <div class="generated-id-preview">
      <span style="font-size: var(--text-xl);" class=" weight-500">Generated ID : </span>{{ generatedId }}
    </div>
    <div v-if="!viewMode" class="type-selector">
      <select :disabled="viewMode" class="sort" v-model="selectedType" @change="addComponent">
        <option disabled value="">+ Select Data Type</option>
        <option v-for="type in dataTypes" :key="type.id" :value="type.caption">
          {{ type.caption }}
        </option>
      </select>
    </div>
    <div class="component-cards">
      <div
        class="component-card"
        v-for="(component, index) in [...components].reverse()"
        :key="component.field_id || component.id"
        :class="{ 'dragging': draggedIndex === index }"
        @dragover.prevent
        @dragenter.prevent
        @drop="handleDrop(index, $event)"
      >
        <div v-if="component.type === 'Auto Sequence'" class="component-row component-header">
          <div v-if="!viewMode" class="col drag-col"></div>
          <div v-if="!viewMode" class="col delete-col"></div>
          <div class="col">Data Type</div>
          <div class="col">Padding</div>
          <div class="col">Last Counter Value</div>
          <div class="col">Delimiter</div>
          <div v-if="!viewMode" class="col col-small">Reset Counter</div>
          <div v-if="component.isChecked || (viewMode && component.select_field && component.select_field.length > 0)" class="col">Select Field</div>
        </div>
        <div v-else class="component-row component-header">
          <div v-if="!viewMode" class="col drag-col"></div>
          <div v-if="!viewMode" class="col delete-col"></div>
          <div class="col">Data Type</div>
          <div class="col">Value</div>
          <div v-if="component.type === 'Tags'" class="col">Tag Seperator</div>
          <div v-if="component.type === 'Config List'" class="col">Config Seperator</div>
          <div class="col">Delimiter</div>
          <div v-if="['Tags', 'Config List'].includes(component.type)" class="col col-small">Abbreviation</div>
        </div>

        <div v-if="component.type === 'Auto Sequence'" class="component-row">
          <div v-if="!viewMode" class="col drag-col">
            <div class="drag-handle" draggable="true" @dragstart="handleDragStart(index, $event)" @dragend="handleDragEnd">
              <img src="~@/assets/images/icons/drag-handle.svg" alt="drag" class="drag-icon" />
            </div>
          </div>
          <div v-if="!viewMode" class="col delete-col">
            <img v-if="(component?.isDelete && !viewMode)" src="~@/assets/images/trash-2.svg" alt="Delete" class="delete-icon" @click="removeComponent(getOriginalIndex(index))" />
          </div>
          <div class="col">{{ getComponentDisplayLabel(component) }}</div>
          <div class="col">
            <input min="0" :disabled="viewMode" type="number" max="10" class="component-input" placeholder="Padding" v-model="component.padding_length" @input="handlePaddingInput(component)" />
          </div>
          <div class="col">
            <input min="0" :disabled="viewMode" type="number" class="component-input" placeholder="Last counter value" v-model="component.lower" @input="updateGeneratedId" />
          </div>
          <div class="col">
            <input v-if="viewMode" class="component-input" :value="component.delimiter || 'Not Selected'" readonly />
            <select v-else class="delimiter-dropdown" v-model="component.delimiter" @change="updateGeneratedId">
              <option value="">Not Selected</option>
              <option value="-">-</option>
              <option value=".">.</option>
              <option value="_">_</option>
            </select>
          </div>
          <div v-if="!viewMode" class="col col-small checkbox-col">
            <input type="checkbox" v-model="component.isChecked" @change="handleResetCheckboxChange(component)" />
          </div>
        <div v-if="component.isChecked || (viewMode && component.select_field && component.select_field.length > 0)" class="col dropdown-col">
          <multiSelectDropdown
            :disableOption="viewMode"
            :options="formattedResetDependencyOptions"
            :initiallySelected="component.select_field || []"
            label="Select Reset Types"
            @selected="handleMultiSelectChange(component, $event)"
            :btnHeight="'40px'"
          />
        </div>
        </div>
        <div v-else class="component-row">
          <div v-if="!viewMode" class="col drag-col">
            <div class="drag-handle" draggable="true" @dragstart="handleDragStart(index, $event)" @dragend="handleDragEnd">
              <img src="~@/assets/images/icons/drag-handle.svg" alt="drag" class="drag-icon" />
            </div>
          </div>
          <div v-if="!viewMode" class="col delete-col">
            <img v-if="!viewMode" src="~@/assets/images/trash-2.svg" alt="Delete" class="delete-icon" @click="removeComponent(getOriginalIndex(index))" />
          </div>
          <div class="col">{{ getComponentDisplayLabel(component) }}</div>
          <div class="col">
            <select v-if="component.options && component.options.length && !viewMode" v-model="component.value" class="component-input" @change="onComponentValueChange(component)">
              <option disabled value="">Select {{ component.type }}</option>
              <option v-for="option in component.options" :key="option.value" :value="option.value">{{ option.name }}</option>
            </select>
            <input
              v-else-if="viewMode"
              class="component-input"
              :value="component.type === 'Tags'
                ? getTagTypeLabel(component.tag_type_id)
                : (component.type === 'Config List' ? (component.custom_list_name || getOptionLabel(component)) : getOptionLabel(component))"
              readonly
            />
            <input
              v-else-if="component.is_dynamic || component.type === 'User Initials'"
              class="component-input"
              :value="getDynamicDisplayLabel(component.component_type || component.type)"
              disabled
            />
            <input
              v-else
              :disabled="viewMode"
              class="component-input"
              :type="component.type === 'Number' ? 'number' : 'text'"
              :placeholder="`Enter ${component.type}`"
              v-model="component.value"
              @input="validateInput(component)"
            />
          </div>
          <div v-if="['Tags', 'Config List'].includes(component.type)" class="col">
            <select v-if="!viewMode" class="delimiter-dropdown" v-model="component.suffix" @change="updateGeneratedId">
              <option value="">Not Selected</option>
              <option value="-">-</option>
              <option value=".">.</option>
              <option value="_">_</option>
            </select>
            <input v-else class="component-input" :value="component.suffix || 'Not Selected'" readonly />
          </div>
          <div class="col">
            <select v-if="!viewMode" class="delimiter-dropdown" v-model="component.delimiter" @change="updateGeneratedId">
              <option value="">Not Selected</option>
              <option value="-">-</option>
              <option value=".">.</option>
              <option value="_">_</option>
            </select>
            <input v-else class="component-input" :value="component.delimiter || 'Not Selected'" readonly />
          </div>
          <div v-if="['Tags', 'Config List'].includes(component.type)" class="col col-small checkbox-col">
          <input type="checkbox" v-model="component.use_abbreviation" :disabled="viewMode" />
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '@/config'
import loadingCircle from '@/components/common/loadingCircle.vue'
import { alert, success } from '@/plugins/notification'
import multiSelectDropdown from '@/components/common/multiselectDropdown.vue'
import { getPartIdDataTypes, GetActiveCustomLists, saveSequenceTemplateGeneration, getTemplateById, displayrootTagName } from '@/api'

const AUTO_SEQUENCE_ID = 3
export default {
  name: 'PartIdGeneration',
  components: { loadingCircle, multiSelectDropdown },
  data () {
    return {
      draggedIndex: null,
      linkedTo: '',
      loading: false,
      viewMode: false,
      recordedId: null,
      templateName: '',
      selectedType: '',
      components: [],
      dataTypes: [],
      generatedId: '',
      customLists: [],
      tagTypeMap: config.TAG_TYPE_MAP,
      coreFeatures: config.CORE_FEATURES,
      selectedFeature: null
    }
  },
  computed: {
    ...mapGetters(['user']),
    userInitials () {
      const firstInitial = this.user?.first_name?.charAt(0) || ''
      const lastInitial = this.user?.last_name?.charAt(0) || ''
      return (firstInitial + lastInitial).toUpperCase()
    },
    formattedResetDependencyOptions () {
      return this.resetDependencyOptions.map(option => ({
        value: option.sequence_order,
        label: option.name
      }))
    },
    resetDependencyOptions () {
      return this.components
        .filter(c => ['Date', 'Month', 'Year', 'Config List', 'Tags', 'User Initials'].includes(c.type))
        .map((c) => ({
          name: this.getComponentDisplayLabel(c),
          sequence_order: this.components.indexOf(c) + 1
        }))
    },
    filteredCoreFeatures () {
      return Object.fromEntries(
        Object.entries(this.coreFeatures)
          .filter(([key]) => ['MATERIAL', 'PRODUCT_CODE', 'FORMS', 'FACTORY'].includes(key))
          .map(([key, value]) => {
            const formattedKey = key.toLowerCase().split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
            return [formattedKey, value]
          })
      )
    }
  },
  mounted () {
    this.loading = true
    this.viewMode = this.$route.path.includes('/view')
    this.recordedId = this.viewMode ? this.$route.params.id || null : null
    this.selectedFeature = this.coreFeatures.MATERIAL
    Promise.all([this.getCustomList(), this.fetchPartIdDataTypes()])
      .then(() => {
        if (this.viewMode && this.recordedId) this.fetchTemplateById()
      })
      .finally(() => { this.loading = false })
  },
  methods: {
    handlePaddingInput (component) {
      let val = Math.floor(component.padding_length)
      if (val > 10) {
        val = 10
      }
      if (val !== '' && val < 1) {
        val = 1
      }
      component.padding_length = val
      this.updateGeneratedId()
    },
    getComponentDisplayLabel (component) {
      const sameTypeItems = this.components.filter(c => c.type === component.type)
      if (sameTypeItems.length <= 1) return component.type
      const occurrenceIndex = sameTypeItems.indexOf(component) + 1
      return `${component.type} ${occurrenceIndex}`
    },
    getDynamicDisplayLabel (type) {
      const t = type.toUpperCase()
      if (t === 'DATE') return 'DD'
      if (t === 'MONTH') return 'MM'
      if (t === 'YEAR') return 'YYYY'
      if (t === 'UUID') return 'XXXX'
      if (t === 'USER INITIALS' || t === 'USER_INITIALS') return this.userInitials
      return ''
    },
    getCustomList () {
      return GetActiveCustomLists().then(res => {
        this.customLists = res.core_custom_list
      })
    },
    async getTags (tagTypeId) {
      return await displayrootTagName(tagTypeId)
    },
    handleDragStart (index, event) {
      this.draggedIndex = index
      event.dataTransfer.effectAllowed = 'move'
      setTimeout(() => { if (event.target.closest('.component-card')) event.target.closest('.component-card').style.opacity = '0.5' }, 0)
    },
    handleDragEnd (event) {
      if (event.target.closest('.component-card')) event.target.closest('.component-card').style.opacity = '1'
      this.draggedIndex = null
    },
    handleDrop (dropIndex, event) {
      event.preventDefault()
      const from = this.getOriginalIndex(this.draggedIndex)
      const to = this.getOriginalIndex(dropIndex)
      const items = [...this.components]
      const [moved] = items.splice(from, 1)
      items.splice(to, 0, moved)
      this.components = items
      this.updateGeneratedId()
    },
    handleMultiSelectChange (component, selectedValues) {
      component.select_field = selectedValues
      this.updateGeneratedId()
    },
    handleResetCheckboxChange (component) {
      if (!component.isChecked) component.select_field = []
      this.updateGeneratedId()
    },
    getTagTypeLabel (tagTypeId) {
      const rawValue = tagTypeId
      const parsedTagTypeId = Number(rawValue)
      if (!Number.isNaN(parsedTagTypeId)) {
        const matchedType = Object.entries(this.tagTypeMap).find(([, value]) => Number(value) === parsedTagTypeId)
        if (matchedType) return matchedType[0]
      }

      const normalized = String(rawValue || '').trim().toUpperCase()
      if (!normalized) return ''
      if (normalized === 'MATERIAL' || normalized === 'MATERIALS') return 'MATERIAL'
      if (normalized === 'TASK' || normalized === 'TASKS') return 'TASK'
      if (normalized === 'FORM' || normalized === 'FORMS') return 'FORM'
      return ''
    },
    getOptionLabel (component) {
      if (component.is_dynamic || component.type === 'User Initials') {
        return this.getDynamicDisplayLabel(component.component_type || component.type)
      }
      if (component.type === 'Tags') {
        return this.getTagTypeLabel(component.tag_type_id ?? component.value ?? component.default_value)
      }
      if (component.type === 'Config List') {
        if (component.custom_list_name) return component.custom_list_name
        const customListId = Number(component.custom_list_id ?? component.value)
        const matchedList = this.customLists.find(l => Number(l.id) === customListId)
        return matchedList?.name || ''
      }
      return component.value
    },
    onComponentValueChange (component) {
      if (component.type === 'Tags') component.tag_type_id = component.value
      else if (component.type === 'Config List') component.custom_list_id = component.value
      this.updateGeneratedId()
    },
    goBack () { this.$router.go(-1) },
    fetchTemplateById () {
      getTemplateById(this.recordedId).then(res => {
        const data = res.core_sequence_id_template_by_pk
        this.templateName = data.name
        this.linkedTo = Object.keys(this.coreFeatures).find(k => this.coreFeatures[k] === data.feature_id)

        this.components = data.id_generation_rules.map((rule, index) => {
          const typeInfo = this.dataTypes.find(dt => dt.id === rule.component_id)
          const type = typeInfo?.caption || rule.component?.caption || 'Unknown'

          const selectedFields = (rule.auto_sequence_reset_rules || []).map(r => {
            const targetRule = data.id_generation_rules.find(orig => orig.id === r.reset_on_field_id)
            return targetRule ? targetRule.sequence_order : null
          }).filter(val => val !== null)

          return {
            id: rule.component_id,
            type: type,
            component_type: type,
            is_dynamic: typeInfo?.is_dynamic || false,
            value: type === 'Tags'
              ? (rule.tag_type_id ?? rule.tag_type?.id ?? rule.default_value ?? '')
              : (type === 'Config List' ? rule.custom_list_id : rule.default_value),
            tag_type_id: type === 'Tags' ? (rule.tag_type_id ?? rule.tag_type?.id ?? null) : null,
            default_value: rule.default_value,
            custom_list_id: type === 'Config List' ? (rule.custom_list_id ?? null) : null,
            custom_list_name: type === 'Config List' ? (rule.core_custom_list?.name || '') : '',
            delimiter: rule.delimiter_after || '',
            lower: rule.start_value,
            padding_length: rule.padding_length,
            suffix: rule.suffix || '',
            use_abbreviation: !!rule.use_abbreviation,
            select_field: selectedFields,
            isChecked: selectedFields.length > 0,
            field_id: crypto.randomUUID(),
            isDelete: true,
            options: type === 'Tags' ? Object.entries(this.tagTypeMap).map(([name, value]) => ({ name, value }))
              : (type === 'Config List' ? this.customLists.map(l => ({ name: l.name, value: l.id })) : [])
          }
        })
        this.updateGeneratedId()
      })
    },
    fetchPartIdDataTypes () {
      return getPartIdDataTypes().then(res => {
        this.dataTypes = res.id_generation_components
        if (!this.viewMode) {
          this.components.push({
            id: AUTO_SEQUENCE_ID,
            type: 'Auto Sequence',
            lower: 1,
            padding_length: 1,
            delimiter: '',
            field_id: crypto.randomUUID(),
            isDelete: true,
            select_field: [],
            isChecked: false
          })
          this.updateGeneratedId()
        }
      })
    },
    validateInput (component) {
      if (component.type === 'Text') {
        component.value = component.value.toUpperCase().replace(/[^A-Z]/g, '')
      }
      this.updateGeneratedId()
    },
    addComponent () {
      if (!this.selectedType) return
      const last = this.components[this.components.length - 1]
      if (last && !last.is_dynamic && last.type !== 'Auto Sequence' && !last.value) {
        alert('Please fill in the value of the last added component before proceeding.')
        this.selectedType = ''
        return
      }

      const selected = this.dataTypes.find(d => d.caption === this.selectedType)
      this.components.push({
        id: selected.id,
        type: selected.caption,
        component_type: selected.caption,
        is_dynamic: selected.is_dynamic,
        value: selected.caption === 'User Initials' ? this.userInitials : '',
        field_id: crypto.randomUUID(),
        delimiter: '',
        select_field: [],
        isChecked: false,
        lower: selected.caption === 'Auto Sequence' ? 1 : '',
        padding_length: selected.caption === 'Auto Sequence' ? 1 : 0,
        suffix: selected.caption === 'Tags' ? '' : selected.caption === 'Config List' ? '' : undefined,
        options: selected.caption === 'Tags' ? Object.entries(this.tagTypeMap).map(([name, value]) => ({ name, value }))
          : (selected.caption === 'Config List' ? this.customLists.map(l => ({ name: l.name, value: l.id })) : [])
      })
      this.selectedType = ''
      this.autoSequeneceDeleteCheck()
      this.updateGeneratedId()
    },
    removeComponent (index) {
      this.components.splice(index, 1)
      this.autoSequeneceDeleteCheck()
      this.updateGeneratedId()
    },
    updateGeneratedId () {
      const parts = this.components.map(c => {
        let val = ''
        if (c.type === 'Auto Sequence') {
          const raw = String(c.lower || '')
          const pad = Number(c.padding_length) || 1
          val = raw.padStart(pad, '0')
        } else if (['Config List', 'Tags'].includes(c.type)) {
          val = 'XXXX'
        } else if (c.is_dynamic || c.type === 'User Initials') {
          val = this.getDynamicDisplayLabel(c.component_type || c.type)
        } else {
          val = String(c.value || '')
        }
        return c.delimiter ? val + c.delimiter : val
      })
      this.generatedId = parts.join('').toUpperCase()
    },
    getOriginalIndex (idx) { return this.components.length - 1 - idx },
    async saveComponent () {
      if (!this.components.length) return alert('Please add at least one component before saving.')
      if (this.components[this.components.length - 1]?.delimiter) return alert('Last component cannot have a delimiter.')
      if (!this.templateName || !this.selectedFeature) return alert('Name and Feature are required.')
      let isInvalid = false
      for (const component of this.components) {
        if (component.type === 'Tags') {
          if (!component.value) {
            alert('Tag type is mandatory!')
            isInvalid = true
          } else {
            const res = await this.getTags(component.value)
            if (!res?.tag || res.tag.length === 0) {
              alert("The selected tag doesn't have any values.")
              isInvalid = true
            }
          }
        }
        if (component.type === 'Config List') {
          if (!component.value) {
            alert('Config List value is mandatory!')
            isInvalid = true
          }
        }
      }
      if (isInvalid) return

      const rules = this.components.map((c, index) => {
        const base = {
          component_id: c.id,
          sequence_order: index + 1,
          component_name: c.type,
          delimiter_after: c.delimiter || null,
          validation_type: null,
          validation_value: null
        }

        if (c.type === 'Auto Sequence') {
          return {
            ...base,
            start_value: Number(c.lower),
            padding_length: Number(c.padding_length),
            reset_on_fields: c.select_field.map(v => Number(v))
          }
        }
        if (c.type === 'Number') {
          return { ...base, default_value: Number(c.value) }
        }
        if (c.type === 'Tags') {
          return { ...base, tag_type_id: Number(c.value), suffix: c.suffix || '', use_abbreviation: !!c.use_abbreviation }
        }
        if (c.type === 'Config List') {
          return { ...base, custom_list_id: Number(c.value), suffix: c.suffix || '', use_abbreviation: !!c.use_abbreviation }
        }
        return { ...base, default_value: c.value }
      })

      this.loading = true
      saveSequenceTemplateGeneration({ name: this.templateName.trim(), feature_id: this.selectedFeature }, rules)
        .then(() => {
          success('Template Saved!')
          this.$router.push('/settings/sequence-generator')
        }).catch((error) => {
          this.loading = false
          if (error.message.includes('Sequence name already exists')) {
            alert('Sequence Name already exists')
          } else {
            alert(error?.message ?? 'Something went wrong.')
          }
        })
        .finally(() => { this.loading = false })
    },
    autoSequeneceDeleteCheck () {
      const autoIndices = this.components.map((c, i) => c.id === AUTO_SEQUENCE_ID ? i : -1).filter(i => i !== -1)
      autoIndices.forEach(i => { this.components[i].isDelete = true })
    }
  }
}
</script>

<style lang="scss" scoped>
  .info-icon {
  width: 12px;
  height: 12px;
  margin-left: 4px;
  vertical-align: middle;
  cursor: pointer;
}
.drag-col {
  width: 40px !important;
  min-width: 40px !important;
  max-width: 40px !important;
  padding: 0 8px !important;
}

.drag-icon {
  width: 20px;
  height: 20px;
  cursor: grab;
}

.drag-handle {
  display: flex;
  align-items: center;
  justify-content: center;
}
.dropdown-col {
  overflow: visible !important;
  position: relative;
  z-index: 1000;
}

::v-deep .dropdown-col .dropdown-content {
  z-index: 9999 !important;
}

::v-deep .dropdown-col .dropdown {
  width: 100% !important;
}

::v-deep .dropdown-col .dropdown-toggle {
  width: 100% !important;
  height: 32px !important;
  font-size: 12px !important;
  padding: 4px 6px !important;
  border: 1px solid var(--brand-color) !important;
  border-radius: 4px !important;
  background-color: var(--brand-light-color) !important;
  box-sizing: border-box !important;
}

::v-deep .dropdown-col .dropdown-content {
  width: 100% !important;
  max-width: 300px;
  font-size: 12px !important;
  border: 1px solid var(--brand-color) !important;
  border-radius: 4px !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;
}

::v-deep .dropdown-col .dropdown-content input[type="text"] {
  font-size: 12px !important;
  padding: 4px 6px !important;
  border: 1px solid var(--brand-color) !important;
  border-radius: 4px !important;
  background-color: var(--brand-light-color) !important;
}

::v-deep .dropdown-col .dropdown-content label {
  font-size: 12px !important;
  padding: 2px 4px !important;
}

::v-deep .dropdown-col .selectedCount {
  font-size: 11px !important;
  padding: 2px 6px !important;
  background: var(--brand-color) !important;
}
.part-id-generation {
  padding: 8px;
}
.new-component-header {
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.generated-id-preview {
  margin-top: 20px;
  font-size: var(--text-l);
  font-weight: 600;
  padding: 10px;
  background-color: #f0f0f0;
  border-radius: 6px;
}

.component-cards {
  margin-top: 20px;
}

.component-card {
  display: table;
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ccc;
  table-layout: fixed;
}

.component-row {
  display: table-row;
  font-size: var(--text-s);
}

.component-header {
  font-weight: 500;
  font-size: var(--text-s);
  background-color: #f3f3f3;
}

.col {
  display: table-cell;
  padding: 8px 8px 8px 8px;
  border: 1px solid #ccc;
  vertical-align: middle;
  word-wrap: break-word;
  overflow-wrap: break-word;
  overflow: hidden;
  font-size: var(--text-s);
}
.col-small {
  display: table-cell;
  padding: 4px 6px;
  width: 11%;
  text-align: center;
  border: 1px solid #ccc;
  vertical-align: middle;
  font-size: var(--text-s);
}
.auto-sequence-col {
  width: auto;
}

.delete-col {
  width: 40px;
  text-align: center;
}

.component-input,
.delimiter-dropdown {
  width: 100%;
  box-sizing: border-box;
  font-size: var(--text-s);
  padding: 4px 6px;
  border: 1px solid var(--brand-color);
  border-radius: 4px;
  background-color: var(--brand-light-color);
}
.auto-padding {
  padding: 4px 6px;
  border: 1px solid var(--brand-color);
  border-radius: 4px;
  background-color: var(--brand-light-color);
  margin-bottom: 4px;
  font-size: var(--text-s);
}

.delete-icon {
  cursor: pointer;
  width: 16px;
  height: 16px;
}

.type-selector {
  margin-top: 20px;
}

.sort {
  height: 2em;
  width: 11.7rem;
  font-size: var(--text-base);
  background-color: var(--brand-light-color);
  line-height: 1;
  border: 1px solid var(--brand-color);
  border-radius: 4px;
  padding: 4px 10px;
}
.status {
  font-size: var(--text-m);
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: fit-content;
  padding: 3px 4px;
  border-radius: 3px;
  background-color: orange;
  &-inprogress {
    background-color: #fff3cd;
    color: #856404;
  }
}
.move-icon {
  width: 20px;
  height: 20px;
}

.auto-sequence {
  display: flex;
  gap: 5px;
}
</style>
